
import { useContext } from "react"
import { updateUser } from "../helpers/firebase"
import { contextApp } from "../../../context/appContext"

const useUpdateUser = (onClose) => {
  const { setOpenAlert, setMensajeAlert, setLoadingData } = useContext(contextApp)

  const update = async (dataUpdate) => {
    setLoadingData(true)
    const response = await updateUser(dataUpdate)
    if (response.status === 'ok') {
      setMensajeAlert({
        severity: 'success',
        message: 'el usuario se editó correctamente',
        duration: 4000
      })
      onClose()
    } else {
      setMensajeAlert({
        severity: 'error',
        message: 'ocurió un error',
        duration: 4000
      })
    }
    setOpenAlert(true)
    setLoadingData(false)
  }

  return { update }
}

export default useUpdateUser